import { z } from "zod";

// ============================================================================
// CONNECT WHATSAPP CLOUD (Direct Meta — Embedded Signup, single step)
// ============================================================================

/**
 * Connect WhatsApp Cloud Body Schema
 *
 * After Embedded Signup completes, the frontend sends the one-time authorization
 * code (from FB.login) plus the waba_id + phone_number_id surfaced via the ES
 * postMessage events. The backend exchanges the code for a token server-side
 * (never to the browser), subscribes the app, and creates the connection.
 */
export const ConnectWhatsAppCloudBodySchema = z.object({
  /** One-time authorization code from the Embedded Signup FB.login code flow */
  code: z.string().min(1),
  /** WhatsApp Business Account id from the ES FINISH event */
  wabaId: z.string().min(1),
  /** Phone number id from the ES FINISH event (the Graph send target) */
  phoneNumberId: z.string().min(1)
});

export type ConnectWhatsAppCloudBody = z.infer<typeof ConnectWhatsAppCloudBodySchema>;

/**
 * Connect WhatsApp Cloud Response Schema
 */
export const ConnectWhatsAppCloudResponseSchema = z.object({
  /** Created ApiKeyConnection id */
  connectionId: z.string().uuid(),
  /** E.164 number Meta shows for the connected sender (display only) */
  displayPhoneNumber: z.string(),
  /** Meta-verified business name on the number */
  verifiedName: z.string()
});

export type ConnectWhatsAppCloudResponse = z.infer<typeof ConnectWhatsAppCloudResponseSchema>;
